import { skipToken } from '@reduxjs/toolkit/query';
import { useFeedlotId } from '../../../../../../commonHooks/useFeedlotId';
import { useAppSelector } from '../../../../../../Redux/Store';
import { reportsApi } from '../../../../../../Redux/Apis/Reports/reportsApi';

export const useGetPenMovements = (penId: number) => {
    const feedlotId = useFeedlotId();
    const { feedEntryRationDetails } = useAppSelector(
        state => state.manualFeedEntry,
    );

    const { currentData, isFetching } =
        reportsApi.useGetApiFmByFlidReportsFeedlotMovementsAndHdCountsQuery(
            feedlotId
                ? {
                      flid: feedlotId,
                      startDate: feedEntryRationDetails.date,
                      penId,
                  }
                : skipToken,
        );

    return {
        penMovements: currentData,
        isFetchingPenMovements: isFetching,
    };
};
